import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import ApplicationEntryRouteConstants from 'ApplicationEntry/ApplicationEntryRouteConstants';
import AWDLogin from 'ApplicationEntry/components/AWDLogin';
import WorkQueue from 'ApplicationEntry/components/WorkQueue';
import {fromLocalStorage, LocalStorageKey} from 'Shared/utilities/localStorage';
import WorkDashboard from 'ApplicationEntry/components/WorkFlow/WorkDashboard';

const getIsLoggedInToAWD = () => {
  const hasSession = Boolean(fromLocalStorage(LocalStorageKey.AWDDSTSession)());
  const hasToken = Boolean(fromLocalStorage(LocalStorageKey.AWDCsrfToken)());

  return hasSession && hasToken;
};

const ApplicationEntryRoutes = () => {
  return (
    <Switch>
      <Route exact path={ApplicationEntryRouteConstants.AWDLogin} render={() => <AWDLogin />} />
      <Route path={'/applicationEntry'} render={() => <AppEntryInnerRoutes />} />
    </Switch>
  );
};

const AppEntryInnerRoutes = () => {
  const isLoggedInToAWD = getIsLoggedInToAWD();

  return isLoggedInToAWD ? (
    <Switch>
      <Route
        exact
        path={ApplicationEntryRouteConstants.WorkQueue}
        render={routeProps => <WorkQueue {...routeProps} />}
      />
      <Route
        exact
        path={ApplicationEntryRouteConstants.ApplicationEntryWizard}
        render={routeProps => <WorkDashboard {...routeProps} />}
      />
    </Switch>
  ) : (
    <Redirect to={ApplicationEntryRouteConstants.AWDLogin} />
  );
};

export default ApplicationEntryRoutes;
